import { OrderHistory } from '../../order-history/order-history.interface';
import {
  MagentoReturnResponse, ReturnCaseAttachment,
  ReturnReason,
  ReturnRequestParams,
  ReturnResponse,
  ReturnType
} from '../interfaces/return-request.interface';

export const mapMagentoResponseToReturnResponse = (response: MagentoReturnResponse): ReturnResponse => {
  return {
    orderId: response.order_id,
    orderIncrementId: response.order_increment_id,
    items: response.items,
    caseNumber: response.return_case_number
  };
};

export const mapOrderToReturnRequestParams = (order: OrderHistory, returnReason: ReturnReason, returnType: ReturnType, attachment?: ReturnCaseAttachment): ReturnRequestParams => {
  return {
    orderId: order.orderId,
    returnRequest: {
      return: {
        notify_user: true,
        return_case: returnType,
        return_reason: returnReason,
        return_case_attachment: attachment,
        items: order.userOrderDetails.map(item => ({
          sku: item.productIsbn,
          reason_code: '01'
        }))
      }
    }
  };
}